module.exports = __webpack_public_path__ + "static/z_tall_oremtigers-25951f71ab9bcf258d424c07fc84729f.jpg";